import FloatingWhats from "../Components/FloatingWhats.jsx";
import Header from "../Components/Header.jsx";
import React, { useState } from "react";
import { Box, Button, Grid2, IconButton, Modal } from "@mui/material";
import BottomBar from "../Components/BottomBar.jsx";
import Footer from "../Components/Footer.jsx";
import styles from "../styles/ProdBal.css"
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Card from "../Components/Card.jsx";

const images = [
    "/images/cc1.png",
    "/images/cc2.png",
    "/images/cc3.png",
];

const ProdBalCC = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const nextImage = () => {
        setCurrentIndex((prev) =>
            prev === images.length - 1 ? 0 : prev + 1
        );
    };

    const prevImage = () => {
        setCurrentIndex((prev) =>
            prev === 0 ? images.length - 1 : prev - 1
        );
    };

    return (
        <div className="container">
            <FloatingWhats/>
            <Header/>    
            <div className="content">
                <div className="bannerInterno-container from-top">
                    <div className="bannerInterno-content">
                        <div className="bannerInterno">
                            <h1 className="bannerInterno-title">CC<br/>Concreto</h1>
                            <img className="bannerInterno-img" src="/images/banner-cc.png" alt="Banner Balança CC"/>
                        </div>
                    </div>
                </div>
                <div className="caminho">
                    <div className="caminho-content from-left">
                        <a className="caminho-link" href="/">Início</a>
                        <span className="caminho-separador">/</span>
                        <a className="caminho-link" href="/produtos">Produtos</a>
                        <span className="caminho-separador">/</span>
                        <a className="caminho-link" href="/produtos/pesagem-rodoviaria">Pesagem Rodoviária</a>
                        <span className="caminho-separador">/</span>
                        <span className="caminho-atual">CC Concreto</span>
                    </div>
                </div>
                <div className="produto-header">
                    <div className="produto-header-content">
                        <div className="produto-header-left from-left">
                            <div className="produto-header-fotosBox">
                                <img className="produto-header-foto" src={images[currentIndex]} alt="Produto" />
                                <button className="produto-header-btn left" onClick={prevImage}><ChevronLeftIcon sx={{ fontSize: 40 }}/></button>
                                <button className="produto-header-btn right" onClick={nextImage}><ChevronRightIcon sx={{ fontSize: 40 }} /></button>
                            </div>
                        </div>
                        <div className="produto-header-right from-right">
                            <div className="produto-header-infoBox">
                                <div className="produto-header-infoBox1">
                                    <h1 className="produto-header-name from-right">CC Concreto</h1>
                                </div>
                                <div className="produto-header-descricao">
                                    <span className="produto-header-info"><strong>Tipo de Plataforma:</strong> Metálica para receber concreto</span>
                                    <span className="produto-header-info"><strong>Dimensão:</strong> De 12 a 60 metros</span>
                                    <span className="produto-header-info"><strong>Capacidade de Pesagem:</strong> 30 a 160 Toneladas</span>
                                    <span className="produto-header-info"><strong>Divisão Programada:</strong> 10 e 20kg</span>
                                    <span className="produto-header-info"><strong>Célula de Carga:</strong> 40 e 50 Toneladas</span>
                                    <span className="produto-header-info"><strong>Estrutura:</strong> Vigas em "I" em aço ASTM a 572 grau 50</span>
                                    <span className="produto-header-info"><strong>Tipo de Pintura:</strong> Automotiva P.U.</span>
                                </div>
                                <div className="produto-header-infoBox3">
                                    <h3 className="produto-header-chamada">
                                        <span style={{color:'#474747'}}>Maior </span>
                                        <span style={{color:'#9E1518'}}>Resistência, Robustez e Durabilidade</span>
                                    </h3>
                                    <a href="https://wa.me/+5545999714611"><Button sx={{fontFamily:'Inter', textTransform:'none', width:'100%', height:90, backgroundColor:'#474747', borderRadius:'8px', color:'#fff', fontSize:'20px','&:hover':{backgroundColor:'#7D1115'}}}>Falar com Vendedor</Button></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="instalacao">
                    <div className="instalacao-content">
                        <h3 className="horario-atendimento-title from-bottom">
                            <span style={{color:'#474747'}}>Tipos de </span>
                            <span style={{color:'#9E1518'}}>Instalação</span>
                        </h3>
                        <div className="instalacao-tiposBox from-bottom">
                            <div className="instalacao-tipos">
                                <img className="instalacao-icon" src="/images/icons/sobrePiso.svg"/>
                                <span className="instalacao-title">Sobre Piso</span>
                            </div>
                            <div className="instalacao-tipos">
                                <img className="instalacao-icon" src="/images/icons/semiEmbutida.svg"/>
                                <span className="instalacao-title">Semi Embutida</span>
                            </div>
                            <div className="instalacao-tipos">
                                <img className="instalacao-icon" src="/images/icons/embutida.svg"/>
                                <span className="instalacao-title">Embutida</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tipoCelulas">
                    <div className="tipoCelulas-content">
                        <h3 className="horario-atendimento-title from-bottom" style={{textAlign:'center', marginBottom:'40px'}}>
                            <span style={{color:'#474747'}}>Células de </span>
                            <span style={{color:'#9E1518'}}>Carga</span>
                        </h3>
                        <div className="lista-produtos from-bottom" style={{marginBottom:'50px'}}>
                            <Grid2  columns={{ xs:4, sm:8, md:12}} container justifyContent={'center'} spacing={5}>
                                <Grid2 item>
                                    <Card link='/produtos/pesagem-rodoviaria/celula-pdx' cardImg={`/images/celula-pdx.png`} title={<>Mettler Toledo<br/>PDX - Digital</>}/>
                                </Grid2>
                                <Grid2 item>
                                    <Card link='/produtos/pesagem-rodoviaria/celula-brc3a' cardImg={`/images/celula-brc3a.png`} title={<>Weightech<br/>BRC3 - Analógica</>}/>
                                </Grid2>
                                <Grid2 item>
                                    <Card link='/produtos/pesagem-rodoviaria/celula-brc3d' cardImg={`/images/celula-brc3d.png`} title={<>Weightech<br/>BRC3 D - Digital</>}/>
                                </Grid2>
                                <Grid2 item>
                                    <Card link='/produtos/pesagem-rodoviaria/celula-bsds' cardImg={`/images/celula-bsds.png`} title={<>Weightech<br/>BSDS - Digital</>}/>
                                </Grid2>
                            </Grid2>
                        </div>
                    </div>
                </div>
                <div className="balOpcional">
                    <h3 className="horario-atendimento-title from-bottom" style={{textAlign:'center', marginBottom:'40px'}}>
                            <span style={{color:'#474747'}}>Produtos </span>
                            <span style={{color:'#9E1518'}}>Opcionais</span>
                    </h3>
                    <div className="home2-content2" style={{marginTop:'0px'}}>
                        <div className="home2-left from-right">
                            <img className='home2-left-img' src='/images/balCad.png'/>
                        </div>
                        <div className="home2-right from-left">
                            <h1 className='home1-title from-left' style={{lineHeight:'40px'}}>
                                <span style={{fontWeight:500, fontSize:'36px'}}>GERENCIAMENTO </span><span style={{fontStyle:'italic', fontSize:'36px'}}>DE PESAGENS (CAD)</span>
                            </h1>
                            <p className="preventiva-text from-left">Atua no gerenciamento de balanças rodoviárias, otimizando o controle de entrada e saída de materiais nas empresas.</p>
                            {/* <a href='/produtos/pesagem-rodoviaria/conversor-analogico-digital' className='home0-link from-left'>
                                <img className='home0-link-icon' src='/images/icons/arrow-right.svg'/>
                                <span>Mais Informações</span>
                            </a> */}
                            <div className="home2-topics from-left">
                                <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='/images/icons/balCad1.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>Sincronização com cameras, semáforos, controle de cancelas, display remoto, sensores de posicionamento e Tags RFID para automação.</span>
                                    </div>
                                </div>
                                <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='/images/icons/balCad2.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>Auditabilidade confiável com registros automáticos de eventos, pesagens e armazenamento em banco de dados compartilhável.</span>
                                    </div>
                                </div>
                                <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='/images/icons/balCad3.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>Integração com sistemas externos, exportando dados como tiquetes de pesagem, eventos e relatórios.</span>
                                    </div>
                                </div>
                                <div className="home2-bar"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ads">
                    <div className="ads-content">
                        <img src="/images/ads-1.png" className="ads-img from-left"/>
                        <img src="/images/ads-2.png" className="ads-img from-right"/>
                    </div>
                </div>
                <div className="obras">
                    <div className="obras-content">
                        <h3 className="horario-atendimento-title from-bottom" style={{textAlign:'center', marginBottom:'40px'}}>
                            <span style={{color:'#474747'}}>Obras </span>
                            <span style={{color:'#9E1518'}}>Realizadas</span>
                        </h3>
                        <Grid2 className='produtos-grid from-bottom' columns={{ xs:4, sm:8, md:12}} container justifyContent={'center'} spacing={'20px'}>
                            <Grid2 item>
                                <img className="obra-img" src='/images/obra-cc1.png'/>
                            </Grid2>
                            <Grid2 item>
                                <img className="obra-img" src='/images/obra-cc2.png'/>
                            </Grid2>
                            <Grid2 item>
                                <img className="obra-img" src='/images/obra-cc3.png'/>
                            </Grid2>
                            <Grid2 item>
                                <img className="obra-img" src='/images/obra-cc4.png'/>
                            </Grid2>
                            <Grid2 item>
                                <img className="obra-img" src='/images/obra-cc5.png'/>
                            </Grid2>
                        </Grid2>
                    </div>
                </div>
                <BottomBar/>
                <Footer/>
            </div>
        </div>
    )
}
export default ProdBalCC;